import { setSession } from "@/utils/methods";
import { isArray } from "@/utils/validate";
import language from "@/utils/checkLang"
import router from "@/router";
import _ from "lodash";
import path from "path";
export default {
  TAG_ADD(state, view) {
    if(view.meta && view.meta.title){
      view.meta.title = view.meta.title.replace("新增",language.configMoudle.add )
      view.meta.title=view.meta.title.replace("修改", language.configMoudle.edit)
      view.meta.title= view.meta.title.replace("详情", language.configMoudle.details)}
    const t = isArray(view);


    if (t) {
      state.tags = view;
    } else {
      if (
        state.tags.some((item, index) => {
          if (item.name == view.name) {
            if (item.path != view.path || item.fullPath != view.fullPath) {
              if(!view.meta.title) return
              state.tags.splice(index, 1, {
                ...view,
                title: view.meta.title || "没有名字",
              });
            }
            return true;
          }
        })
      )
        return;
      if(!view.meta.title) return
      state.tags.push(
        Object.assign({}, view, {
          title: view.meta.title || "没有名字",
        })
      );
      setSession("tags", state.tags);
    }
  },
  TAG_DEL(state, obj) {
    const { handle, routePath } = obj;

    if (handle) {
      const curId = state.tags.findIndex((item) => item.path === routePath);
      switch (handle) {
        case "closeLeft":
          state.tags.splice(1, curId - 1);
          break;
        case "closeRight":
          state.tags.splice(curId + 1);
          break;
        case "closeOther":
          curId === 0
            ? state.tags.splice(curId + 1)
            : (state.tags = [state.tags[0], state.tags[curId]]);

          break;
        case "closeAll":
          state.tags.splice(1);
          if (routePath !== "/home") router.push("/");
      }
    } else {
      if (routePath === "/home") return;
      state.tags = state.tags.filter((item) => item.path !== routePath);
    }
    setSession("tags", state.tags);

  },

  ROUTES_SET(state, router) {
    state.routes = router;
  },
  GET_USERINFO(state, userInfo) {
    state.userInfo = userInfo
    setSession("userInfo", userInfo);
  },
  saveModuleMainFormData(state, info){
    state.moduleMainFormData = info
  },
  /**
   * 添加缓存的关闭标签页面 (列表页的标签删除)
   */
  ADD_TAG_CLEAR_CATCH(state,info){
    let data = state.tagCloseRouteList
    if (info){
      data.push(info)
    }
    state.tagCloseRouteList = data
  },
  /**
   * 删除缓存的关闭标签页面 (列表页的标签删除)
   */
  DEL_TAG_CLEAR_CATCH(state,info){ 
    let data = state.tagCloseRouteList
    if (info){
      data.splice(data.indexOf(info),1)
    }
    state.tagCloseRouteList = data
  },
  /**
   * 添加缓存的关闭标签页面 (详情页的标签删除)
   */
  ADD_TAG_CLEAR_DETAIL_CATCH(state,info){
    let data = state.tagCloseDetailRouteList
    if (info){
      data.push(info)
    }
    state.tagCloseDetailRouteList = data
  },
  /**
   * 删除缓存的关闭标签页面 (详情页的标签删除)
   */
  DEL_TAG_CLEAR_DETAIL_CATCH(state,info){
    let data = state.tagCloseDetailRouteList
    if (info){
      data.splice(data.indexOf(info),1)
    }
    state.tagCloseDetailRouteList = data
  },
  
  CLICK_TAG(state, isClick) {
    state.isClickTag = isClick
  },
};
